import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'input[inputOtp]',
})
export class InputOTPDirective {
  @HostListener('keyup', ['$event']) onKeyDown(keyboardEvent: KeyboardEvent) {    
    const target = keyboardEvent.target as
      | HTMLInputElement
      | HTMLTextAreaElement
      | null;

    if (!target) return;
    const { type } = target;
    let { nextElementSibling, previousElementSibling } = target;
      if(keyboardEvent.key == 'Backspace') {
        while (previousElementSibling) {
          if (
            (previousElementSibling as HTMLInputElement | HTMLTextAreaElement).type ===
            type
          ) {
            (previousElementSibling as HTMLInputElement | HTMLTextAreaElement).select();
            return;
          }
          previousElementSibling = previousElementSibling.nextElementSibling;
        }
    } else {
        if(target.maxLength !== target.value.length) return;
        keyboardEvent.preventDefault();
        while (nextElementSibling) {
          if (
            (nextElementSibling as HTMLInputElement | HTMLTextAreaElement).type ===
            type
          ) {
            (nextElementSibling as HTMLInputElement | HTMLTextAreaElement).select();
            return;
          }
          nextElementSibling = nextElementSibling.nextElementSibling;
        }
      }
    }


}